import * as React from 'react';
import {InferableComponentEnhancer} from 'recompose';
import {connect} from 'react-redux';
import {FormName} from 'redux-form';

export default function formConnect<P extends object = {}>(
  mapStateToProps,
  mapDispatchToProps = {}
): InferableComponentEnhancer<P> {
  return function(WrappedComponent) {
    const Connected = connect(
      mapStateToProps,
      mapDispatchToProps
    )(WrappedComponent as any);
    return props => <FormName>{({form}) => <Connected form={form} {...props} />}</FormName>;
  };
}
